import { createIsomorphicFn } from "@tanstack/react-start";

type CacheOpts = { maxAge?: number; sMaxAge?: number; swr?: number };

/**
 * Ustawia HTTP Cache-Control podczas SSR (Cloudflare/Worker edge cache).
 * No-op po stronie klienta — implementacja serwerowa wstrzykiwana przez bundler.
 */
export const setEdgeCache = createIsomorphicFn()
  .client((_opts?: CacheOpts) => {})
  .server(async (opts?: CacheOpts) => {
    const maxAge = opts?.maxAge ?? 0;
    const sMaxAge = opts?.sMaxAge ?? 3600;
    const swr = opts?.swr ?? 86400;
    try {
      const { setResponseHeaders } = await import("@tanstack/react-start/server");
      setResponseHeaders(
        new Headers({
          "Cache-Control": `public, max-age=${maxAge}, s-maxage=${sMaxAge}, stale-while-revalidate=${swr}`,
        }),
      );
    } catch {
      // Brak request context (np. prerender) — ignorujemy.
    }
  });
